import useSWR from 'swr'
import { buildCacheKey } from '../../shared/utils/cache'
import { getUser } from './api'
import { useHermesSdkConfig } from '../../use-hermes-sdk-config'

export const useUserData = (userUuid: string) => {
  const config = useHermesSdkConfig()
  const cacheKey = buildCacheKey('useUserData', { userUuid })
  const {
    data,
    isLoading,
    error,
    mutate: refresh
  } = useSWR(cacheKey, () => getUser({ userUuid }, config), {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  })

  return {
    data,
    isLoading,
    error,
    refresh
  }
}
